import React, { useState } from "react";
import { Button, Card, Form, Input, Typography, message } from "antd";
import { useNavigate } from "react-router-dom";
import { loginCustomer, getCurrentCustomer } from "../api/authApi";
import { setAuth } from "../utils/authStorage";

const { Title } = Typography;

export default function LoginPage() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            const loginRes = await loginCustomer({
                username: values.username,
                password: values.password,
            });

            const token = loginRes?.token;
            if (!token) {
                throw new Error("Token missing from login response");
            }

            localStorage.setItem("customer_access_token", token);

            let me = null;
            try {
                me = await getCurrentCustomer();
            } catch {
                me = {
                    username: values.username,
                };
            }

            setAuth(token, me);
            message.success("Login successful");
            navigate("/dashboard", { replace: true });
        } catch (error) {
            if (error?.errorFields) return;
            message.error(error.message || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "grid",
                placeItems: "center",
                padding: 24,
            }}
        >
            <Card style={{ width: 420 }}>
                <Title level={3}>Customer Login</Title>

                <Form form={form} layout="vertical">
                    <Form.Item
                        name="username"
                        label="Username"
                        rules={[{ required: true, message: "Username is required" }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        label="Password"
                        rules={[{ required: true, message: "Password is required" }]}
                    >
                        <Input.Password />
                    </Form.Item>

                    <Button type="primary" block loading={loading} onClick={handleSubmit}>
                        Login
                    </Button>
                </Form>
            </Card>
        </div>
    );
}